module.exports = __webpack_public_path__ + "img/img-ct-mathematical.93260ee9.png";